import { Component, Inject } from '@angular/core';
import { filter, first, of, Subject, switchMap, takeUntil, tap } from 'rxjs';
import { AppEnvironmentState, InfoService, LIBRARY_CONFIG, UserState } from '../../../shared';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "../../../shared";
import * as i3 from "@angular/common/http";
import * as i4 from "@angular/common";
import * as i5 from "@ngx-translate/core";
function VersionModalComponent_td_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "UI-LIB.HEADER.ENVIRONMENT_TAG.TOOLTIP.FRONTEND_VERSION"));
  }
}
function VersionModalComponent_td_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "UI-LIB.HEADER.ENVIRONMENT_TAG.TOOLTIP.BACKEND_VERSION"));
  }
}
function VersionModalComponent_td_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "UI-LIB.HEADER.ENVIRONMENT_TAG.TOOLTIP.LIB_VERSION"));
  }
}
function VersionModalComponent_td_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "UI-LIB.HEADER.ENVIRONMENT_TAG.TOOLTIP.DB_VERSION"));
  }
}
export class VersionModalComponent {
  store;
  infoApi;
  httpClient;
  environment = null;
  frontendVersion = '';
  backendVersion = '';
  dbVersion = '';
  libVersion = '';
  destroyed$ = new Subject();
  backendInfoUrl;
  constructor(store, infoApi, httpClient, libConfig) {
    this.store = store;
    this.infoApi = infoApi;
    this.httpClient = httpClient;
    this.backendInfoUrl = libConfig.backendInfoUrl;
  }
  ngOnInit() {
    this.store.select(AppEnvironmentState.appEnvironmentState).pipe(takeUntil(this.destroyed$), filter(state => state?.environment !== null), tap(state => this.environment = state?.environment), filter(state => state?.environment !== undefined)).subscribe(() => {
      this.fetchInfo();
    });
  }
  fetchInfo() {
    this.infoApi.getFrontendVersions().pipe(first()).subscribe(versions => {
      if (versions) {
        this.frontendVersion = this.formatVersion(versions.app, versions.timestamp, versions.branch);
        this.libVersion = versions.lib;
      } else {
        console.warn('Versions are missing. Please configure a versions.json in your app assets folder.');
      }
    });
    this.store.select(UserState.token).pipe(filter(token => !!token), switchMap(() => this.backendInfoUrl ? this.httpClient.get(`${this.backendInfoUrl}`) : of({})), first()).subscribe(info => {
      this.dbVersion = info.databaseSchema?.version ?? '';
      this.backendVersion = this.formatVersion(info.build?.version ?? '', info.build?.timestamp ?? '', info.git?.branch ?? '');
    });
  }
  formatVersion(version, timestamp, branch) {
    return `${version} (Time: ${timestamp}, Branch: ${branch})`;
  }
  ngOnDestroy() {
    this.destroyed$.next();
  }
  static ɵfac = function VersionModalComponent_Factory(t) {
    return new (t || VersionModalComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.InfoService), i0.ɵɵdirectiveInject(i3.HttpClient), i0.ɵɵdirectiveInject(LIBRARY_CONFIG));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: VersionModalComponent,
    selectors: [["geaui-version-modal"]],
    features: [i0.ɵɵProvidersFeature([InfoService])],
    decls: 19,
    vars: 8,
    consts: [[1, "version-modal"], ["aria-label", "version overview table"], [1, "version-modal-row"], [4, "ngIf"]],
    template: function VersionModalComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "table", 1);
        i0.ɵɵelement(2, "th");
        i0.ɵɵelementStart(3, "tr", 2);
        i0.ɵɵtemplate(4, VersionModalComponent_td_4_Template, 3, 3, "td", 3);
        i0.ɵɵelementStart(5, "td");
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "tr", 2);
        i0.ɵɵtemplate(8, VersionModalComponent_td_8_Template, 3, 3, "td", 3);
        i0.ɵɵelementStart(9, "td");
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(11, "tr", 2);
        i0.ɵɵtemplate(12, VersionModalComponent_td_12_Template, 3, 3, "td", 3);
        i0.ɵɵelementStart(13, "td");
        i0.ɵɵtext(14);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(15, "tr", 2);
        i0.ɵɵtemplate(16, VersionModalComponent_td_16_Template, 3, 3, "td", 3);
        i0.ɵɵelementStart(17, "td");
        i0.ɵɵtext(18);
        i0.ɵɵelementEnd()()()();
      }
      if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.frontendVersion);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.frontendVersion);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.backendVersion);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.backendVersion);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.libVersion);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.libVersion);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.dbVersion);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.dbVersion);
      }
    },
    dependencies: [i4.NgIf, i5.TranslatePipe],
    styles: [".version-modal[_ngcontent-%COMP%]{font-size:16px;font-weight:500;padding-bottom:40px}.version-modal[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{line-height:20px}.version-modal[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:nth-child(1){padding-right:10px}.version-modal[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:nth-child(2){font-weight:600}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VersionModalComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-version-modal',
      providers: [InfoService],
      template: "<div class=\"version-modal\">\n  <table aria-label=\"version overview table\">\n    <th></th>\n    <tr class=\"version-modal-row\">\n      <td *ngIf=\"frontendVersion\">{{ 'UI-LIB.HEADER.ENVIRONMENT_TAG.TOOLTIP.FRONTEND_VERSION' | translate }}</td>\n      <td>{{ frontendVersion }}</td>\n    </tr>\n    <tr class=\"version-modal-row\">\n      <td *ngIf=\"backendVersion\">{{ 'UI-LIB.HEADER.ENVIRONMENT_TAG.TOOLTIP.BACKEND_VERSION' | translate }}</td>\n      <td>{{ backendVersion }}</td>\n    </tr>\n    <tr class=\"version-modal-row\">\n      <td *ngIf=\"libVersion\">{{ 'UI-LIB.HEADER.ENVIRONMENT_TAG.TOOLTIP.LIB_VERSION' | translate }}</td>\n      <td>{{ libVersion }}</td>\n    </tr>\n    <tr class=\"version-modal-row\">\n      <td *ngIf=\"dbVersion\">{{ 'UI-LIB.HEADER.ENVIRONMENT_TAG.TOOLTIP.DB_VERSION' | translate }}</td>\n      <td>{{ dbVersion }}</td>\n    </tr>\n  </table>\n</div>\n",
      styles: [".version-modal{font-size:16px;font-weight:500;padding-bottom:40px}.version-modal tr{line-height:20px}.version-modal td:nth-child(1){padding-right:10px}.version-modal td:nth-child(2){font-weight:600}\n"]
    }]
  }], () => [{
    type: i1.Store
  }, {
    type: i2.InfoService
  }, {
    type: i3.HttpClient
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [LIBRARY_CONFIG]
    }]
  }], null);
})();
